var React = require('react');

function CustomAccessRulesKeyIcon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#fy0oap7yta)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 44C17.457 44 11.648 40.858 8 36H3.21C7.36 43.174 15.117 48 24 48c13.254 0 24-10.745 24-24S37.254 0 24 0C15.116 0 7.36 4.826 3.21 12h4.788C11.648 7.142 17.457 4 24 4c11.046 0 20 8.954 20 20s-8.954 20-20 20zM7 27a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-10a7.003 7.003 0 0 1 6.71 5H32v7h-4v-3h-4v3h-4v-3h-6.29A7 7 0 1 1 7 17z","fill":"#8D6CFF"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"fy0oap7yta"},React.createElement("path",{"fill":"#fff","d":"M0 0h48v48H0z"})))]);
}

CustomAccessRulesKeyIcon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = CustomAccessRulesKeyIcon;

CustomAccessRulesKeyIcon.default = CustomAccessRulesKeyIcon;
